module.exports = __webpack_public_path__ + "assets/img/ceb.512bd567.png";